import { AccountType, IBank } from "@/interfaces/talk2pay.iterfaces";
import { BankAccountDialogMessages } from "@/messages/platforms/talk2PayHome/bank-account-dialog.messages";
import { SelectData } from "@/types/form.types";

export const ACCOUNT_TYPE_OPTIONS = (
  messages: BankAccountDialogMessages
): SelectData<AccountType>[] => {
  return [
    { value: AccountType.CORRENTE, label: messages.accountTypeCheckingLabel },
    { value: AccountType.POUPANCA, label: messages.accountTypeSavingsLabel },
  ];
};

export const BANKS_OPTIONS = (banks?: IBank[]): SelectData<string>[] => {
  if (!banks) return [];
  return banks.map((bank) => ({
    value: bank.name,
    label: `${bank.code} - ${bank.name}`,
  }));
};

export const BANK_ACCOUNT_TABLE_COLUMNS = (messages: BankAccountDialogMessages) => {
  return [
    messages.nicknameLabel,
    messages.bankLabel,
    messages.accountTypeLabel,
    messages.agencyLabel,
    messages.accountNumberColumnLabel,
    messages.optionsColumnLabel,
  ];
};
